import { initialiseDatadog } from '@library/observability/browser'

/**
 * Starts RUM monitoring including XHR / fetch observation
 */
initialiseDatadog()
